/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_DATA_COPY,
  ADD_DATA_SCHEDULING,
  AGENT_OFFICE_VACANCY_LIST,
  AGENT_VANCANY_LIST,
  LOAD_RECORDS_META_DATA,
  LOAD_DATA_SCHEDULING,
  LOAD_DATA_SCHEDULING_SERVICE,
  REMOVE_DATA_SERVICE,
  SHOOTER_HISTORY_LIST,
  DATA_FINAL_COMMIT,
  UPDATE_DATA_SCHEDULING,
  LOAD_NAS_LINK_DETAILS,
  ADD_NAS_LINK,
  DELETE_NAS_LINK,
  LOAD_DATA_LINK_DETAILS,
  UPDATE_NAS_LINK,
  UPDATE_DATA_LINK,
  LOAD_SERVICE_LEVEL,
  DELETE_DATA_LINK,
  ADD_DATA_LINK,
  UPLOAD_QC,
  UPDATE_NAS_COMMIT,
  LOAD_PENDING_STATUS,
  UPDATE_DATA_COPY,
  UPDATE_EXPAND,
  LOAD_DATA_DETAILS,
  LOAD_EXPAND_DATA
  // UPDATE_DATA_SCHEDULING_SERVICE,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadDataCopy,
  loadDataCopyError,
  loadDataCopySuccess,
  addDataSchedulingSuccess,
  loadDataScheduling,
  loadDataSchedulingSuccess,
  loadDataSchedulingError,
  addDataSchedulingError,
  loadShooterHistory,
  loadShooterHistorySuccess,
  loadShooterHistoryError,
  updateDataSchedulingSuccess,
  updateDataSchedulingError,
  dataFinalCommitSuccess,
  dataFinalCommitError,
  loadAgentVacancy,
  loadAgentVacancySuccess,
  loadAgentVacancyError,
  loadAgentOfficeVacancy,
  loadAgentOfficeVacancySuccess,
  loadAgentOfficeVacancyError,
  loadDataSchedulingService,
  loadDataSchedulingServiceSuccess,
  loadDataSchedulingServiceError,
  removeDataSchedulingSuccess,
  removeDataSchedulingError,
  loadNasLinkList,
  loadNasLinkListSuccess,
  loadNasLinkListError,
  addNasLinkSuccess,
  addNasLinkError,
  removeNasLinkSuccess,
  removeNasLinkError,
  updateNasLinkSuccess,
  updateNasLinkError,
  loadDataLinkList,
  loadDataLinkListSuccess,
  loadDataLinkListError,
  addDataLinkSuccess,
  addDataLinkError,
  removeDataLinkSuccess,
  removeDataLinkError,
  updateDataLinkSuccess,
  updateDataLinkError,
  loadServiceLevel,
  loadServiceLevelSuccess,
  loadServiceLevelError,
  uploadQcSuccess,
  uploadQcError,
  updateNasCommitSuccess,
  updateNasCommitError,
  loadPendingStatus,
  loadPendingStatusSuccess,
  loadPendingStatusError,
  updateCopySuccess,
  updateCopyError,
  updateExpandSuccess,
  updateExpandError,
  loadDataDetailsSuccess,
  loadDataDetailsError,
  loadExpandData,
  loadExpandDataSuccess,
  loadExpandDataError
} from "./actions"

import {
  loadDataCopyDetails,
  loadRecordsMetaData,
  // addClearanceLevelDetails,
  // updateEventCompleteDetails,
  loadDataSchedulingDetails,
  addDataSchedulingDetails,
  loadShooterHistoryDetails,
  dataCommitDetails,
  updateDataSchedulingDetails,
  // loadEventTeamSchedlingDetails,
  loadAgentVacancyDetails,
  loadAgentOfficeVacancyDetails,
  // loadFreelancerListDetails,
  loadDataSchedulingServiceDetails,
  removeDataSchedulingDetails,
  loadNasLinkDetails,
  addNasLinkDetails,
  removeNasLinkDetails,
  updateNasLinkDetails,
  loadDataLinkDetails,
  addDataLinkDetails,
  removeDataLinkDetails,
  updateDataLinkDetails,
  loadServiceLevelDetails,
  uploadQcDetails,
  updateNasCommitDetails,
  loadPendingStatusDetails,
  updateCopyDetails,
  updateExpandDetails,
  loadDataDetails,
  loadExpandDataDetails
} from "./remotes"

function* loadDataCopyDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_DATA_COPY),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadDataCopy(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDataCopyDetails, searchvalue)
        console.log("api result is", result)

        if (result) {
          yield put(loadDataCopySuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadDataCopySuccess([]))
          yield put(loadDataCopyError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadDataCopySuccess([]))
        yield put(
          loadDataCopyError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const company = yield call(loadRecordsMetaData, "company", "post")
      const branch = yield call(loadRecordsMetaData, "branch", "post")
     
      const event = yield call(loadRecordsMetaData, "event", "post")
      const employee = yield call(
        loadRecordsMetaData,
        "employee_dropdown_list",
        "post"
      )
    const copyStatus = yield call(loadRecordsMetaData,"service_level_status","post")
      const processStatus = yield call(
        loadRecordsMetaData,
        "process_status",
        "post"
      )
    const service = yield call(loadRecordsMetaData, "service", "post")
      let recordsMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          (company &&
            company.length > 0 &&
            company.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        copyStatusOptions: (copyStatus &&
          copyStatus.data &&
          copyStatus.data.length > 0 &&
          copyStatus.data
            .filter((_) => _.status === 1)
            .map((c) =>
              Object.assign(
                {},
                {
                  label: c.serviceLevelName,
                  value: c._id,
                  colorCode: c.colorCode,
                  //  companyId: c.companyId
                }
              )
            )) ||
        [],
        serviceOptions: (service &&
          service.data &&
          service.data.length > 0 &&
          service.data
            .filter((_) => _.status === 1)
            .map((c) =>
              Object.assign(
                {},
                {
                  label: c.serviceName,
                  value: c.serviceName,
                  isDataApplicable: c.isDataApplicable
                }
              )
            )) ||
        [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.name, value: c._id, companyId: c.companyId }
                )
              )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
        eventOptions:
          (event &&
            event.data &&
            event.data.length > 0 &&
            event.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.eventName,
                    value: c._id,
                    eventCode: c.eventCode,
                    //  companyId: c.companyId
                  }
                )
              )) ||
          [],
      

        

        processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p._id,
                    processStatusId: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
        employeeOptions:
          (employee &&
            employee.data &&
            employee.data.length > 0 &&
            employee.data.map((c) =>
              Object.assign(
                {},
                {
                  label: c.empCode.concat(" - ", c.name),
                  value: c._id,
                }
              )
            )) ||
          [],
        employeeListOptions:
          (employee &&
            employee.data &&
            employee.data.length > 0 &&
            employee.data.map((c) =>
              Object.assign(
                {},
                {
                  label: c.empCode.concat(" - ", c.name),
                  value: c._id,
                }
              )
            )) ||
          [],
      
      }
      console.log(recordsMetaData, "my details")
      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
// add clearance


function* loadDataSchedulingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_DATA_SCHEDULING),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadDataScheduling(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
     
        const result = yield call(loadDataSchedulingDetails, id)

        if (result) {
          yield put(loadDataSchedulingSuccess(result.data))
        } else {
          yield put(loadDataSchedulingError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadDataSchedulingError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}


//Data Service details
function* loadDataScheduleServiceSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_DATA_SCHEDULING_SERVICE),
    })

    const { explicitLoad } = load
    const { record } = explicitLoad || {}
    yield put(loadDataSchedulingService(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDataSchedulingServiceDetails, record)

        if (result) {
          yield put(loadDataSchedulingServiceSuccess(result.data))
        } else {
          yield put(loadDataSchedulingServiceError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadDataSchedulingServiceError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addDataSchedulingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_DATA_SCHEDULING),
    })
    const { dataScheduling } = create || {}

    if (create) {
      console.log("records", dataScheduling)
      try {
        yield call(addDataSchedulingDetails, dataScheduling)

        var successVal = addDataSchedulingSuccess(
          dataScheduling,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          addDataSchedulingError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* removeDataSchedulingDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(REMOVE_DATA_SERVICE),
    })
    const { dataScheduling } = create || {}

    if (create) {
      console.log("records", dataScheduling)
      try {
        yield call(removeDataSchedulingDetails, dataScheduling)

        var successVal = removeDataSchedulingSuccess(
          dataScheduling,
          "Record Removed Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          removeDataSchedulingError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* updateDataSchedulingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_DATA_SCHEDULING),
    })
    const { dataScheduling } = create || {}

    if (create) {
      console.log("records", dataScheduling)
      try {
        yield call(updateDataSchedulingDetails, dataScheduling)

        var successVal = updateDataSchedulingSuccess(
          dataScheduling,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          updateDataSchedulingError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadAgentVacancyDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(AGENT_VANCANY_LIST),
    })

    const { explicitLoad } = load

    const { record } = explicitLoad || {}
    yield put(loadAgentVacancy(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadAgentVacancyDetails, record)

        if (result) {
          yield put(loadAgentVacancySuccess(result.data))
        } else {
          yield put(loadAgentVacancyError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadAgentVacancyError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadAgentOfficeVacancyDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(AGENT_OFFICE_VACANCY_LIST),
    })

    const { explicitLoad } = load

    const { record } = explicitLoad || {}
    yield put(loadAgentOfficeVacancy(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadAgentOfficeVacancyDetails, record)

        if (result) {
          yield put(loadAgentOfficeVacancySuccess(result.data))
        } else {
          yield put(loadAgentOfficeVacancyError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadAgentOfficeVacancyError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadShooterHistorySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(SHOOTER_HISTORY_LIST),
    })

    const { explicitLoad } = load

    const { empId } = explicitLoad || {}
    yield put(loadShooterHistory(explicitLoad.empId)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadShooterHistoryDetails, empId)

        if (result) {
          yield put(loadShooterHistorySuccess(result.data))
        } else {
          yield put(loadShooterHistoryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadShooterHistoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* dataFinalCommitSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(DATA_FINAL_COMMIT),
    })
    const { finalCommit } = create || {}

    if (create) {
      console.log("records", finalCommit)
      try {
        yield call(dataCommitDetails, finalCommit)

        var successVal = dataFinalCommitSuccess(
          finalCommit,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          dataFinalCommitError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Nas Link

function* loadNasLinkDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_NAS_LINK_DETAILS),
    })

    const { explicitLoad } = load
    const { record } = explicitLoad || {}
    yield put(loadNasLinkList(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadNasLinkDetails, record)

        if (result) {
          yield put(loadNasLinkListSuccess(result.data))
        } else {
          yield put(loadNasLinkListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadNasLinkListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addNasLinkDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_NAS_LINK),
    })
    const { nasLinkDetails } = create || {}

    if (create) {
      console.log("records", nasLinkDetails)
      try {
        yield call(addNasLinkDetails, nasLinkDetails)

        var successVal = addNasLinkSuccess(
          nasLinkDetails,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          addNasLinkError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* removeNasLinkDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(DELETE_NAS_LINK),
    })
    const { deleteNasLinkData } = create || {}

    if (create) {
      console.log("records", deleteNasLinkData)
      try {
        yield call(removeNasLinkDetails, deleteNasLinkData)

        var successVal = removeNasLinkSuccess(
          deleteNasLinkData,
          "Record Removed Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          removeNasLinkError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* updateNasLinkDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_NAS_LINK),
    })
    const { nasLinkDetails } = create || {}

    if (create) {
      console.log("records", nasLinkDetails)
      try {
        yield call(updateNasLinkDetails, nasLinkDetails)
        var successVal = updateNasLinkSuccess(
          nasLinkDetails,
          "Record Created Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          updateNasLinkError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Data Link
function* loadDataLinkDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_DATA_LINK_DETAILS),
    })

    const { explicitLoad } = load
    const { record } = explicitLoad || {}
    yield put(loadDataLinkList(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDataLinkDetails, record)

        if (result) {
          yield put(loadDataLinkListSuccess(result.data))
        } else {
          yield put(loadDataLinkListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadDataLinkListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addDataLinkDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_DATA_LINK),
    })
    const { dataLinkDetails } = create || {}

    if (create) {
      console.log("records", dataLinkDetails)
      try {
        yield call(addDataLinkDetails, dataLinkDetails)

        var successVal = addDataLinkSuccess(
          dataLinkDetails,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          addDataLinkError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* removeDataLinkDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(DELETE_DATA_LINK),
    })
    const { dataLinkDetails } = create || {}

    if (create) {
      console.log("records", dataLinkDetails)
      try {
        yield call(removeDataLinkDetails, dataLinkDetails)

        var successVal = removeDataLinkSuccess(
          dataLinkDetails,
          "Record Removed Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          removeDataLinkError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* updateDataLinkDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_DATA_LINK),
    })
    const { dataLinkDetails } = create || {}

    if (create) {
      console.log("records", dataLinkDetails)
      try {
        yield call(updateDataLinkDetails, dataLinkDetails)

        var successVal = updateDataLinkSuccess(
          dataLinkDetails,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          updateDataLinkError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
//loadServiceLevel
function* loadServiceLevelSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_SERVICE_LEVEL),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadServiceLevel(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadServiceLevelDetails, searchvalue)
      

        if (result) {
          yield put(loadServiceLevelSuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadServiceLevelSuccess([]))
          yield put(loadServiceLevelError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadServiceLevelSuccess([]))
        yield put(
          loadServiceLevelError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//uploadQc
function* uploadQcSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPLOAD_QC),
    })
    const { qcDetails } = create || {}

    if (create) {
      console.log("records", qcDetails)
      try {
        yield call(uploadQcDetails, qcDetails)

        var successVal = uploadQcSuccess(
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          uploadQcError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//update nas commit
function* updateNasCommitSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_NAS_COMMIT),
    })
    const { nasCommitDetails } = create || {}

    if (create) {
    
      try {
        yield call(updateNasCommitDetails, nasCommitDetails)

        var successVal =updateNasCommitSuccess(
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
         updateNasCommitError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
  //loadPendingStatusSaga
function* loadPendingStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_PENDING_STATUS),
    })

    const { explicitLoad } = load

    const { pendingDetails } = explicitLoad || {}
    yield put(loadPendingStatus(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPendingStatusDetails, pendingDetails)
      

        if (result) {
          yield put(loadPendingStatusSuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadPendingStatusSuccess([]))
          yield put(loadPendingStatusError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadPendingStatusSuccess([]))
        yield put(
          loadPendingStatusError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* updateCopySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_DATA_COPY),
    })
    const { copyDetails } = create || {}

    if (create) {
    
      try {
        yield call(updateCopyDetails,copyDetails)

        var successVal =updateCopySuccess(
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
         updateCopyError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
//

function* updateExpandSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_EXPAND),
    })
    const { expandDetails } = create || {}

    if (create) {
    
      try {
        yield call(updateExpandDetails,expandDetails)

        var successVal = updateExpandSuccess(
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
         updateExpandError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
//loadDataDetails



function* loadDataDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_DATA_DETAILS),
    })

    const { explicitLoad } = load

    const { dataService } = explicitLoad || {}
    yield put(loadDataDetails(explicitLoad.dataService)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
     
        const result = yield call(loadDataDetails, dataService)
        console.log(result,"result")
        if (result) {
          yield put(loadDataDetailsSuccess(result.data))
        } else {
          yield put(loadDataDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadDataDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadExpandDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EXPAND_DATA),
    })

    const { explicitLoad } = load

    const { pendingDetails } = explicitLoad || {}
    yield put(loadExpandData(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadExpandDataDetails, pendingDetails)
      

        if (result) {
          yield put(loadExpandDataSuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadExpandDataSuccess([]))
          yield put(loadExpandDataError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadExpandDataSuccess([]))
        yield put(
          loadExpandDataError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadDataCopyDetailsSaga(),
    loadDataSchedulingSaga(),
    addDataSchedulingSaga(),
    updateDataSchedulingSaga(),
    removeDataSchedulingDetailsSaga(),
    loadShooterHistorySaga(),
    dataFinalCommitSaga(),
    loadAgentVacancyDetailsSaga(),
    loadAgentOfficeVacancyDetailsSaga(),
    loadDataScheduleServiceSaga(),

    //Nas Link
    loadNasLinkDetailsSaga(),
    addNasLinkDetailsSaga(),
    updateNasLinkDetailsSaga(),
    removeNasLinkDetailsSaga(),
    updateExpandSaga(), 
    // Data Link
    loadDataLinkDetailsSaga(),
    addDataLinkDetailsSaga(),
    updateDataLinkDetailsSaga(),
    removeDataLinkDetailsSaga(),
    loadServiceLevelSaga(),
    uploadQcSaga(),
    updateNasCommitSaga(),
    loadPendingStatusSaga(),
    loadPendingStatusSaga(),
    updateCopySaga(),
    loadDataDetailsSaga(),
    loadExpandDataSaga()
  ])
}
